module.exports = __webpack_public_path__ + "img/eye-off.09b16233.svg";